import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import { StreamActions } from "@hotwired/turbo"

import Modal from 'bootstrap/js/dist/modal';
import Dropdown from "bootstrap/js/dist/dropdown";
import Tab from "bootstrap/js/dist/tab";

import "./turbo-django.js"

Stimulus.load(definitionsFromContext(require.context("../../../misc/static/js/controllers", true, /\.js$/)))
Stimulus.load(definitionsFromContext(require.context("../../../payments/static/js/controllers", true, /\.js$/)))

StreamActions.dynamic_modal = function(){
  const modal_container = document.querySelector(this.getAttribute('target'));

  const existing_modal = modal_container.querySelector('.modal')

  if (existing_modal){
    Modal.getInstance(modal_container.querySelector('.modal')).hide();
  }

  modal_container.innerHTML = this.querySelector('template').innerHTML

  const modal = new Modal(modal_container.querySelector('.modal'))
  modal.show()
}

